exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;600;700&display=swap);", ""]);

// module
exports.push([module.id, ".autospin.landscape{top:118.33333px;right:35px}.autospin.landscape.inverted{left:30px;right:auto}.autospin.landscape.autospin_interface_open{top:100px}.autospin.landscape.bet_interface_open{top:155px}.autospin.portrait{-webkit-transform-origin:top right;transform-origin:top right;left:50%;margin-left:-165px;top:20%}.autospin.portrait.inverted{margin-left:85px;-webkit-transform-origin:top left;transform-origin:top left}.autospin.portrait.inverted.autospin_interface_open{right:-40px}.autospin.portrait.autospin_interface_open{bottom:65px;left:auto;right:220px}", ""]);

// exports
exports.locals = {
	"autospin": "autospin",
	"landscape": "landscape",
	"inverted": "inverted",
	"autospin_interface_open": "autospin_interface_open",
	"autospinInterfaceOpen": "autospin_interface_open",
	"bet_interface_open": "bet_interface_open",
	"betInterfaceOpen": "bet_interface_open",
	"portrait": "portrait"
};